export const isValidAustralianLandlineNumber = (number: string) => {
  const clean = number?.replace(/[\s-]/g, '');
  const regex1 = /^0[2-8]\d{8}$/;
  const regex2 = /^[2-8]\d{7}$/;
  const isValid = regex1.test(clean || '') || regex2.test(clean || '');
  return isValid;
};

export const normalizeAustralianMobileNumber04OrPlus614 = (number: string) => {
  const clean = String(number || '')
    .trim()
    .replace(/[\s()-]/g, '');
  if (/^04\d{8}$/.test(clean)) {
    return clean;
  }
  if (/^\+614\d{8}$/.test(clean)) {
    return clean;
  }
  return null;
};

export const isValidAustralianMobileNumber04OrPlus614 = (number: string) => {
  return Boolean(normalizeAustralianMobileNumber04OrPlus614(number));
};
